module.exports = __webpack_public_path__ + "334fc193d893b80b7d5736ee103b406d.svg";